<template>
  <section>
    <div class="primary-header">
      <h1 data-qa="Content-Firmware-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
      <el-button
        @click="showAddFirmware"
        data-qa="Content-AddFirmware-Button"
        id="btn-firmware-form"
        type="warning"
      >
        {{ $t('firmwareButtonAddFirmwareText') }}
      </el-button>
    </div>
    <el-table
      :data="firmwareList"
      :default-sort="defaultSort"
      :element-loading-text="$t('firmwareTableLoadingText')"
      class="firmware-table"
      data-qa="Content-Firmware-Table"
      element-loading-background="#FFFFFF"
      fit
      header-row-class-name="firmware-table__header"
      max-height="100%"
      show-header
      v-loading="loading"
    >
      <el-table-column :label="$t('firmwareTableColVersionLabel')" prop="version" sortable min-width="100"></el-table-column>
      <el-table-column :label="$t('firmwareTableColPreviousVersionLabel')" prop="previousVersion" min-width="90"></el-table-column>
      <el-table-column :label="$t('firmwareTableColSHA1Label')" prop="sha1" min-width="320"></el-table-column>
      <el-table-column :label="$t('firmwareTableColModelLabel')" prop="model" min-width="90"></el-table-column>
      <el-table-column :label="$t('firmwareTableColSizeLabel')" prop="size" min-width="90"></el-table-column>
      <el-table-column :label="$t('firmwareTableColTriggerLabel')" prop="trigger" min-width="90">
        <template slot-scope="scope">
        <el-switch disabled=true :value="!!scope.row.trigger"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="" fixed="right" min-width="60">
        <template slot-scope="scope">
          <el-tooltip :content="$t('firmwareTooltipDownloadText')" effect="dark" placement="top-start">
            <a :data-qa="`Content-DownloadFirmware-Button-${scope.row.index}`" :href="scope.row.url" class="el-button el-button--mini el-button--text">
              <i class="fa fa-download fa-2 operation-icons"></i>
            </a>
          </el-tooltip>
          <el-tooltip :content="$t('firmwareTooltipDeleteText')" effect="dark" placement="top-start">
            <el-button
              :data-qa="'Content-DeleteFirmware-Button-' + scope.row.index"
              @click="delFirmware(firmwareList[scope.row.index])"
              type="text"
              size="mini"
            >
              <i class="fa fa-trash fa-2 operation-icons"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <firmware-delete></firmware-delete>
    <firmware-upload></firmware-upload>
  </section>
</template>

<script>
import main from './Firmware.js'
export default main
</script>

<style lang="scss" scoped>
@import './Firmware.scss'
</style>



// WEBPACK FOOTER //
// Firmware.vue?b4c667ba